import type { AppState } from '@/types/appState';
import { SortByOptions } from '@shared/generated/models/SortByOptions';
import { SortDirectionOptions } from '@shared/generated/models/SortDirectionOptions';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAppStore = defineStore('appState', () => {
  const loading = ref<AppState['loading']>(false);
  const hiddenAnnouncements = ref<AppState['hiddenAnnouncements']>(
    localStorage.getItem('hideAnnouncements')
      ? JSON.parse(localStorage.getItem('hideAnnouncements')!)
      : []
  );
  const sidebarOpen = ref<AppState['sidebarOpen']>(
    !localStorage.getItem('sidebarOpen')
      ? true
      : localStorage.getItem('sidebarOpen') === 'true'
  );
  //remove after new job list
  const jobSorting = ref<AppState['jobSorting']>(
    JSON.parse(localStorage.getItem('jobSorting') as string) || {
      sortBy: SortByOptions.CURRENT_STAGE_STARTED_AT,
      sortDirection: SortDirectionOptions.ASC
    }
  );
  //TODO remove individual filters after new job list, combine with jobFilters
  const paymentStatusFilter = ref<AppState['paymentStatusFilter']>(
    JSON.parse(localStorage.getItem('paymentStatusFilter') as string) || []
  );
  const programStatusFilter = ref<AppState['programStatusFilter']>(
    JSON.parse(localStorage.getItem('programStatusFilter') as string) || []
  );
  const programsFilter = ref<AppState['programsFilter']>(
    JSON.parse(localStorage.getItem('programsFilter') as string) || []
  );
  const createdByFilter = ref<AppState['createdByFilter']>(
    JSON.parse(localStorage.getItem('createdByFilter') as string) || []
  );
  const stagesFilter = ref<AppState['stagesFilter']>(
    JSON.parse(localStorage.getItem('stagesFilter') as string) || []
  );
  const actionRequiredFilter = ref<AppState['actionRequiredFilter']>(
    !localStorage.getItem('actionRequiredFilter')
      ? false
      : localStorage.getItem('actionRequiredFilter') === 'true'
  );

  //TODO: remove after new job list
  const setJobSorting = (newJobSorting: AppState['jobSorting']) => {
    jobSorting.value = newJobSorting;
    localStorage.setItem('jobSorting', JSON.stringify(jobSorting.value));
  };

  const hideAnnouncement = (announcementId: string) => {
    hiddenAnnouncements.value.push(announcementId);
    localStorage.setItem(
      'hideAnnouncements',
      JSON.stringify(hiddenAnnouncements.value)
    );
  };

  //TODO remove individual filters after new job list, combine with jobFilters
  const setPaymentStatusFilter = (
    paymentStatus: AppState['paymentStatusFilter']
  ) => {
    paymentStatusFilter.value = paymentStatus;
    localStorage.setItem(
      'paymentStatusFilter',
      JSON.stringify(paymentStatusFilter.value)
    );
  };
  const setProgramStatusFilter = (
    programStatus: AppState['programStatusFilter']
  ) => {
    programStatusFilter.value = programStatus;
    localStorage.setItem(
      'programStatusFilter',
      JSON.stringify(programStatusFilter.value)
    );
  };
  const setProgramsFilter = (programs: AppState['programsFilter']) => {
    programsFilter.value = programs;
    localStorage.setItem(
      'programsFilter',
      JSON.stringify(programsFilter.value)
    );
  };
  const setCreatedByFilter = (claimedBy: AppState['createdByFilter']) => {
    createdByFilter.value = claimedBy;
    localStorage.setItem(
      'createdByFilter',
      JSON.stringify(createdByFilter.value)
    );
  };

  const setStagesFilter = (stages: AppState['stagesFilter']) => {
    stagesFilter.value = stages;
    localStorage.setItem('stagesFilter', JSON.stringify(stagesFilter.value));
  };

  const toggleActionRequiredFilter = () => {
    actionRequiredFilter.value = !actionRequiredFilter.value;
    localStorage.setItem(
      'actionRequiredFilter',
      actionRequiredFilter.value.toString()
    );
  };

  return {
    loading,
    hiddenAnnouncements,
    sidebarOpen,
    jobSorting,
    setJobSorting,
    hideAnnouncement,
    paymentStatusFilter,
    setPaymentStatusFilter,
    programStatusFilter,
    setProgramStatusFilter,
    programsFilter,
    setProgramsFilter,
    createdByFilter,
    setCreatedByFilter,
    actionRequiredFilter,
    toggleActionRequiredFilter,
    stagesFilter,
    setStagesFilter
  };
});
